import LogoutIcon from '@mui/icons-material/Logout';
import { Box, Button, FormControlLabel, Grid, IconButton, Menu, MenuItem } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../../contexts/authWindows';
import { ConnectedServices } from '../../../types/app/appInfo.types';
import { paths } from '../../../utils/core/routes';
import * as api from '../../../api/app/appInfoApi';
import { useTranslation } from '../../../contexts/translation';
import LanguageIcon from '@mui/icons-material/Language';
import { LanguageChanger } from '../../../components/app/LanguageChanger/LanguageChanger';
import { Lang, TranslateLang } from '../../../types/core/lang.types';
import Switch from '@mui/material/Switch';
import { ThemeType, useLocalTheme } from '../../../hooks/useLocalTheme';
export function NavMenuProfile() {
  const { user, signOut } = useAuth();
  const theme = useTheme();
  const { localTheme, changeLocalTheme } = useLocalTheme();
  const navigate = useNavigate();
  const { t, lang } = useTranslation();
  const [isLanguageDialogOpen, setIsLanguageDialogOpen] = useState<boolean>(false);
  const [isDarkTheme, setIsDarkTheme] = useState<boolean>(false);
  const { data } = useQuery<ConnectedServices>(
    ['connectedServices'],
    () => api.getConnectedServices(),
    { refetchInterval: false },
  );
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    setIsDarkTheme(localTheme === ThemeType.DARK);
  }, [localTheme]);

  const handleLogout = () => {
    if (signOut) signOut();
    navigate(paths.HOME);
  };

  return (
    <>
      <Box
        sx={{
          width: '100%',
        }}
      >
        <Grid container sx={{ display: 'flex', alignItems: 'center' }}>
          <Grid item sx={{ flexGrow: 100 }}>
            <Typography variant="h6" style={{ float: 'left' }}>
              {t('navigation.headline-app-name')}
            </Typography>
          </Grid>
          <Grid style={{ flexGrow: 1 }}>
            <FormControlLabel
              control={
                <Switch
                  checked={isDarkTheme}
                  onChange={() => {
                    changeLocalTheme();
                  }}
                  style={{ float: 'right', cursor: 'pointer' }}
                  name="dark"
                  color="default"
                />
              }
              label={<Typography variant="h6">{t('theme.theme-type-1')}</Typography>}
            />
          </Grid>
          <Grid item style={{ flexGrow: 1 }}>
            <Typography
              variant="h6"
              noWrap
              style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
              onClick={() => setIsLanguageDialogOpen(true)}
            >
              <LanguageIcon style={{ marginRight: 2 }} />
              <span>{t(TranslateLang[lang as Lang])}</span>
            </Typography>
          </Grid>
          <Grid item style={{ flexGrow: 1 }}>
            <Typography
              variant="h6"
              noWrap
              component="div"
              textAlign={'right'}
              style={{ float: 'right' }}
            >
              {user ? (
                <div>
                  <Button
                    id="demo-positioned-button"
                    aria-controls={open ? 'demo-positioned-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                    onClick={handleClick}
                  >
                    <Typography
                      variant="h6"
                      noWrap
                      component="div"
                      textAlign={'right'}
                      style={{ float: 'right' }}
                    >
                      {user.name}
                    </Typography>
                  </Button>
                  <Menu
                    id="demo-positioned-menu"
                    aria-labelledby="demo-positioned-button"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'left',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'left',
                    }}
                  >
                    <MenuItem onClick={handleClose}>
                      <IconButton
                        title="Logout"
                        aria-label="Logout"
                        size="small"
                        onClick={handleLogout}
                      >
                        <LogoutIcon fontSize="small" style={{ marginRight: '20px' }} />
                        {t('general.action-buttons.log-out')}
                      </IconButton>
                    </MenuItem>
                  </Menu>
                </div>
              ) : (
                data && (
                  <Link
                    to={`${paths.LOGIN_PAGE}`}
                    style={{ color: theme.palette.primary.main, fontWeight: 600 }}
                  >
                    {t('general.action-buttons.log-in')}
                  </Link>
                )
              )}
            </Typography>
          </Grid>
        </Grid>
      </Box>
      <LanguageChanger
        isOpen={isLanguageDialogOpen}
        onClose={() => setIsLanguageDialogOpen(false)}
      />
    </>
  );
}
